import { render, staticRenderFns } from "./ShipAccess.vue?vue&type=template&id=8837fd64&scoped=true"
import script from "./ShipAccess.vue?vue&type=script&lang=js"
export * from "./ShipAccess.vue?vue&type=script&lang=js"
import style0 from "./ShipAccess.vue?vue&type=style&index=0&id=8837fd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8837fd64",
  null
  
)

export default component.exports